import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars
import fileObjectPropType from '../fileObject';

const { arrayOf, bool, number, objectOf, oneOfType, shape, string } = PropTypes;

export default shape({
  accessRestricted: bool,
  cipherText: string,
  conditionCode: string,
  contentType: string,
  createdBy: string,
  createdDate: string,
  description: oneOfType([string, arrayOf(string)]),
  displayName: string,
  displayOnly: bool,
  encryptionKeyID: string,
  example: string,
  fieldID: string,
  fieldName: string,
  hints: string,
  intent: string,
  isCreatedByApp: bool,
  isRequired: bool,
  isSensitive: bool,
  items: bool,
  nextVersion: string,
  path: string,
  predictedBy: string,
  previousVersion: string,
  processID: string,
  processName: string,
  restrictions: shape({
    choices: arrayOf(string),
    max: number,
    min: number,
    multiple: bool,
    pattern: string,
    schema: oneOfType([objectOf(string), string])
  }),
  runID: string,
  tableID: string,
  teamName: string,
  type: string,
  userID: string,
  value: oneOfType([
    arrayOf(fileObjectPropType),
    arrayOf(string),
    bool,
    fileObjectPropType,
    number,
    PropTypes.any,
    string
  ]),
  visibility: string,
  visibleToUsers: arrayOf(string)
});



// WEBPACK FOOTER //
// ./js/types/api/field.js